export class DsgRequestTypeFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<DsgRequestType>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<DsgRequestType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DsgRequestTypeFilters.attributeTypeMap;
    }
    constructor() {
    }
}
